/**
 * @param domNode {HTMLElement}
 * @param styleKey {String}
 * @param styleValue {any}
 * */
function setStyleProperty (domNode, styleKey, styleValue) {
  domNode.style.setProperty(styleKey, styleValue)
}

/**
 * @param domNode {HTMLElement}
 * @param styleKey {String}
 * */
function getStyleProperty (domNode, styleKey) {
  domNode.style.getPropertyValue(styleKey)
}

export { setStyleProperty, getStyleProperty }
